export enum FkorderPublicationStatusEnum {
  NOT_SYNCED = '0',
  PENDING = '1',
  SYNCED = '2',
}

export const FkorderPublicationStatus = [
  { label: '未反映', value: FkorderPublicationStatusEnum.NOT_SYNCED },
  { label: '反映待ち', value: FkorderPublicationStatusEnum.PENDING },
  { label: '反映済み', value: FkorderPublicationStatusEnum.SYNCED },
];
